(function () {
  const COLOR_PATTERN = /^(Skin|Brown|Black)/i;
  const STYLE_ID = 'variant-gallery-filter-style';

  function getColor(str) {
    if (!str) return null;
    const m = str.match(COLOR_PATTERN);
    return m ? m[1] : null;
  }

  async function initCard(card) {
    const swatchLinks = card.querySelectorAll('.card-swatches a[title]');
    if (!swatchLinks.length) return;

    const firstHref = swatchLinks[0].getAttribute('href');
    const handle = firstHref.match(/\/products\/([^?]+)/)?.[1];
    if (!handle) return;

    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    const media = product.media || [];

    const colorImages = {};
    media.forEach(m => {
      const alt = m.alt || '';
      const color = getColor(alt);
      if (!color || !alt.toLowerCase().includes('scene')) return;
      if (!colorImages[color]) colorImages[color] = { main: null, hover: null };
      if (alt.match(/-1$/i)) colorImages[color].main = m.src;
      if (alt.match(/-2$/i)) colorImages[color].hover = m.src;
    });

    swatchLinks.forEach(link => {
      link.style.position = 'relative';
      link.style.zIndex = '10';
      link.style.pointerEvents = 'auto';

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const color = link.getAttribute('title');
        const colorKey = getColor(color);
        if (!colorKey || !colorImages[colorKey]) return;

        const { main, hover } = colorImages[colorKey];
        const imgs = card.querySelectorAll('.card__media img, .card__inner img, .media img');
        if (imgs[0] && main) {
          imgs[0].src = main;
          imgs[0].srcset = main;
        }
        if (imgs[1] && hover) {
          imgs[1].src = hover;
          imgs[1].srcset = hover;
        }

      // 更新 variant ID
      const variantInput = card.querySelector('.product-variant-id');
      if (variantInput) {
        const variantId = link.href.match(/variant=(\d+)/)?.[1];
        if (variantId) variantInput.value = variantId;
      }

        swatchLinks.forEach(l => l.style.outline = '');
        link.style.outline = '2px solid #000';
      }, true);
    });
  }

  function initAll() {
    document.querySelectorAll('.card-wrapper').forEach(card => initCard(card));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
